export const pokemonPro = {
    title:"Pokémon project",
    title2:"Proyecto de pokémon",
    description:"This project was made during Henry bootcamp, it consumes pokeapi and has features like filters, orders, create new pokémons, view details of them and more.",
    description2:"Este proyecto fue hecho durante el Henry bootcamp, consume pokeapi y tiene características como filtros, ordenamientos, crear nuevos pokémons, ver sus detalles y más.",
    img:"../../utils/preview-pokemon.jpg",
    deploy:"https://pokemon-proyect-mu.vercel.app/",
    repo:"https://github.com/SebastianCalabro/Pokemon-Proyect",
    tecnologies:["react","redux","express","sequelize","postgresql","css3","html5", "nodejs", "javascript"]
}
export const kembaPro = {
    title: "Sneaker E-commerce",
    title2:"E-commerce de zapatillas",
    description:"This was my first grupal project using agile scrum methodology, it has features like , catalog, ordering, registration, payment gateway, shopping cart, favorites and dashboard available only for administrators wich gives absolute control of the page.",
    description2:"Este fue mi primer proyecto grupal utilizando la metodología ágil scrum, tiene características como , catálogo, ordenamientos, capacidad de registrarse, pasarela de pago, carrito de compras, favoritos y panel disponible sólo para los administradores.",
    img:"../../utils/preview-kemba.jpg",
    deploy:"https://pf-henry.vercel.app/",
    repo:"https://github.com/SebastianCalabro/PF---Henry",
    tecnologies:["react","redux","express","sequelize","postgresql","css3","html5", "nodejs", "javascript"]
}
export const weatherPro = {
    title: "Weather TS project",
    title2:"Api de clima con TS",
    description:"This is my first experience integrating TypeScript to one of my projects, it consumes a wheather API and have the function of searching different cities to see it",
    description2:"Esta es mi primera experiencia integrando TypeScript a uno de mis proyectos, consume una API del clima y tiene la funcion de buscar distintas ciudades para verlo",
    img:"../../utils/preview-weather.jpg",
    deploy:"https://weather-app-typescript-six.vercel.app/",
    repo:"https://github.com/SebastianCalabro/Weather-App-TypeScript",
    tecnologies:["react","redux","css3","html5","typescript"]
}